import React, { Fragment, useMemo } from 'react';
import cx from 'classnames';
import type { CartItemType } from '@zola-helpers/client/dist/es/@types/cart';
import type { WProjectCustomizationFullView } from '@zola/svc-web-api-ts-client';
import type { ConvertWebApiDeclaredToActual } from '@zola-helpers/client/dist/es/@types/svc-web-api';
import CompactCurrencyFilter from '../../utils/PricingUtils';

import { CardItemAttributeList } from './CardItemAttributes';

import { CartItemPrice } from '../CartItemPrice';
import { CartItemDetails } from '../CartItemDetails';
import { CartItemName } from '../CartItemName';
import { CartItemQuantity } from '../CartItemQuantity';
import styles from './cardSubItem.module.less';
import cartContainerStyles from '../../stylesheets/cartContainer.module.less';

export const CardSubItem = ({
  item,
  customization,
}: {
  item: CartItemType;
  customization: ConvertWebApiDeclaredToActual<WProjectCustomizationFullView> | null;
}) => {
  const mobilePrice = useMemo(() => {
    if (item.contribution?.adjustedPrice === 0) {
      return 'Free';
    }
    const perEach = CompactCurrencyFilter(item.contribution?.adjustedPrice);

    return `${perEach} each`;
  }, [item.contribution?.adjustedPrice]);

  const attributes = useMemo(() => {
    return [
      ...(item.attributes || []),
      {
        label: 'Quantity',
        value: `${item.contribution?.quantity || 0}`,
        className: cartContainerStyles.visibleContainerSmall,
      },
      { label: 'Price', value: mobilePrice, className: cartContainerStyles.visibleContainerSmall },
    ];
  }, [item.attributes, item.contribution?.quantity, mobilePrice]);

  return (
    <Fragment>
      <div
        className={cx(styles.cardSubItemDetails, {
          [styles.withEnhancedPaper]: true,
        })}
      >
        <CartItemDetails smallerFont>
          <CartItemName smallerFont>{item.name}</CartItemName>
          <CardItemAttributeList attributes={attributes} />
        </CartItemDetails>
      </div>
      <CartItemPrice item={item} smallerFont />
      <CartItemQuantity smallerFont>{item.contribution?.quantity}</CartItemQuantity>
      <div />
    </Fragment>
  );
};

export default CardSubItem;
